import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { config } from "./../../utils/index";
import S3FileUpload from "react-s3";
import { Progress } from "react-sweet-progress";
import { phoneRegExp } from "../../constant";
import { toast } from "react-toastify";
import Select from "react-select";
import { clearTeacherDetail, TeacherDetailReducer } from "../slice";
import { EditTeacherProfile } from "../../api/teacher";
import CreatableSelectInput from "./../../component/CreatableSelectField/CreatableSelectInput";
import Loader from "./../../component/Loader";
import moment from "moment";
import BackButton from "../../component/BackButton";
import { FetchCompanySettings } from "../slice";
window.Buffer = window.Buffer || require("buffer").Buffer;

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4060/api/";

const getYears = () => {
  let startYear = 1970;
  let endYear = moment().get("y");
  let datesArray = [];
  while (startYear <= endYear) {
    datesArray.unshift(startYear);
    startYear++;
  }
  return datesArray;
};

export const months = [
  {
    id: 1,
    value: "January",
  },
  {
    id: 2,
    value: "February",
  },
  {
    id: 3,
    value: "March",
  },
  {
    id: 4,
    value: "April",
  },
  {
    id: 5,
    value: "May",
  },
  {
    id: 6,
    value: "June",
  },
  {
    id: 7,
    value: "July",
  },
  {
    id: 8,
    value: "August",
  },
  {
    id: 9,
    value: "September",
  },
  {
    id: 10,
    value: "October",
  },
  {
    id: 11,
    value: "November",
  },
  {
    id: 12,
    value: "December",
  },
];

function EditTeacher() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(false);
  const [time, setTime] = useState(0);
  const detail = useSelector((store) => store.main.teacherDetail);
  const currentUser = useSelector((store) => store.subAdmin.detail);
  const companySettings = useSelector((store) => store.main.companySettings);
  const [loading, setLoading] = useState(false);
  const [yearList, setYearList] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageDoc, setSelectedImageDoc] = useState([]);
  const isTeacherSelf = currentUser?.is_teacher === 1;

  const isMembershipEnabled = companySettings?.membership !== false;
  const isEventsEnabled = companySettings?.events !== false;

  let companyOptions = [];
  const companiesStr = localStorage.getItem('companies');
  if (companiesStr) {
    try {
      const companies = JSON.parse(companiesStr);
      if (Array.isArray(companies) && companies.length > 0) {
        companyOptions = [
          ...companies.map(c => ({
            value: c.id,
            label: c.company_name
          }))
        ];
      }
    } catch (e) {
      // Optionally handle JSON parse error
      companyOptions = [];
    }
  }
  const [selectedCompany, setSelectedCompany] = useState(0);

  useEffect(() => {
    if (id) {
      setLoading(true);
      dispatch(TeacherDetailReducer({ id: id })).then(() => {
        setLoading(false);
      });
    }
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(FetchCompanySettings());
  }, [dispatch]);
  useEffect(() => {
    return () => {
      dispatch(clearTeacherDetail({}));
    };
  }, [dispatch]);

  useEffect(() => {
    let interval;
    if (isActive && time < 100) {
      interval = setInterval(() => {
        // if (time < 100)
        setTime((seconds) => (seconds < 99 ? seconds + 1 : seconds));
      }, 10);
    }
    return () => clearInterval(interval);
  }, [isActive, time]);

  useEffect(() => {
    if (yearList?.length === 0) {
      let minYear = moment().subtract(4, "years").format("YYYY");
      let years = [];
      for (let i = 1920; i <= minYear; i++) {
        years.push(i?.toString());
      }
      years.sort((a, b) => b - a);
      setYearList(years);
    }
  }, [yearList?.length]);

  const years = getYears();
  if (!detail) {
    return <Loader />;
  } else {
    return (
      <article className="col-lg-9 articleClass">
        <div className="article-body store-bd-gy">
          <div className="row align-items-center col-rever">
            {!isTeacherSelf && <BackButton />}
            <div className="col-sm-12 col-md-12 col-lg-12 mb-3 text-center">
              <h3>Edit Teacher</h3>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-sm-12">
              <Formik
                initialValues={{
                  image: detail?.image || "",
                  fullName: detail?.full_name || "",
                  company_id: detail?.company_id || "",
                  email: detail?.email || "",
                  countryCode: detail?.countryCode || "44",
                  mobile: detail?.mobile || "",
                  document:
                    detail?.document_list?.map((it) => it?.document) || [],
                  toggle: "false",
                  address: {
                    property_number: detail?.address?.property_number || "",
                    property_name: detail?.address?.property_name || "",
                    street_number: detail?.address?.street_number || "",
                    town: detail?.address?.town || "",
                    country: detail?.address?.country || "",
                    postal_code: detail?.address?.postal_code || "",
                    // dob: detail?.address?.dob || "",
                    day: detail?.address?.dob_day || "",
                    month: detail?.address?.dob_month || "",
                    year: detail?.address?.dob_year || "",
                  },
                  modules: {
                    area: detail?.modules?.area || false,
                    booking: detail?.modules?.booking || false,
                    classes: detail?.modules?.classes || false,
                    discipline: detail?.modules?.discipline || false,
                    earning: detail?.modules?.earning || false,
                    event_Type: detail?.modules?.event_Type || false,
                    events: detail?.modules?.events || false,
                    import_export_data: detail?.modules?.import_export_data || false,
                    membership: detail?.modules?.membership || false,
                    newsletter: detail?.modules?.newsletter || false,
                    notification: detail?.modules?.notification || false,
                    register: detail?.modules?.register || false,
                    user: detail?.modules?.user || false,
                    student: detail?.modules?.student || false,
                    venue: detail?.modules?.venue || false
                  },
                }}
                enableReinitialize={true}
                validationSchema={Yup.object({
                  image: Yup.string().notRequired(),
                  fullName: Yup.string().required("Required"),
                  password: Yup.string().notRequired().optional(),
                  email: Yup.string()
                    .email("Kindly enter a valid email.")
                    .required("Required")
                    .test("checkEmailDuplication", "This email is already in use", async function (value) {
                      if (!value) return true;
                      try {
                        const token = localStorage.getItem("token");
                        const response = await fetch(
                          `${BASE_URL}admin/checkEmailDuplication?email=${encodeURIComponent(value)}&id=${id}&user_type=teacher`,
                          { headers: { token } }
                        );
                        const data = await response.json();
                        return !data.data.exists;
                      } catch (err) {
                        return true;
                      }
                    }),
                  mobile: Yup.string()
                    .matches(phoneRegExp, "Kindly enter a valid phone number.")
                    .required("Required"),
                  countryCode: Yup.string().required("Required"),
                  document: Yup.array().notRequired(),
                  address: Yup.object({
                    property_number: Yup.string().required("Required"),
                    street_number: Yup.string().required("Required"),
                    town: Yup.string().required("Required"),
                    country: Yup.string().required("Required"),
                    postal_code: Yup.string().required("Required"),

                    // dob: Yup.string().required("Required"),
                    day: Yup.string().required("Required"),
                    month: Yup.string().required("Required"),
                    year: Yup.string().required("Required"),
                  }),
                })}
                onSubmit={(values) => {
                  setSubmitting(true);
                  let payload = {
                    profile_image: selectedImage,
                    full_name: values?.fullName,
                    email: values?.email,
                    mobile: values?.mobile,
                    countryCode: values?.countryCode,
                    password: values.password || "",
                    // dob: moment(values.dob).format("YYYY-MM-DD"),
                    dob_day: values?.address?.day,
                    dob_month: values?.address?.month,
                    dob_year: values?.address?.year,
                    document: JSON.stringify(values?.document),
                    property_number: values?.address?.property_number,
                    property_name: values?.address?.property_name,
                    street_number: values?.address?.street_number,
                    town: values?.address?.town,
                    country: values?.address?.country,
                    postal_code: values?.address?.postal_code,
                    teacherId: id,
                  };

                  if (!isTeacherSelf) {
                    payload.company_id = values?.company_id;
                  }
                  // Add documents to payload with dynamic keys
                  selectedImageDoc.forEach((file, index) => {
                    payload[`document${index + 1}`] = file;
                  });

                  if (!isTeacherSelf) {
                    let module_payload = {};
                    for (const key in values?.modules) {
                      if (Object.hasOwnProperty.call(values?.modules, key)) {
                        let element = values?.modules[key];
                        if (key === "membership" && !isMembershipEnabled) element = false;
                        if ((key === "events" || key === "event_Type") && !isEventsEnabled) element = false;
                        console.log(key, element);
                        if (key === "id" || key === "adminId") {
                          continue;
                        } else {
                          module_payload = {
                            ...module_payload,
                            [key]: element === true ? "1" : "0",
                          };
                        }
                      }
                    }
                    payload['modules'] = JSON.stringify(module_payload);
                  }

                  EditTeacherProfile(payload).then((res) => {
                    setSubmitting(false);

                    if (res?.code === 1) {
                      toast.success(res?.message, { autoClose: false, closeButton: true });
                      if (!isTeacherSelf) {
                        navigate("/teacher", { replace: true });
                      }
                    } else {
                      toast.error(res?.message, { autoClose: false, closeButton: true });
                    }
                  });
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFormikState,
                  setFieldValue,
                  /* and other goodies */
                }) => (
                  <form className="form-style" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 mb-4">
                        <div className="form-group text-center">
                          <div className="upload-btn-wrapper">
                            <button className="btn">
                              {time > 0 && isActive ? (
                                <Progress
                                  type="circle"
                                  width={80}
                                  percent={time}
                                />
                              ) : (
                                <img
                                  src={
                                    values.image
                                      ? values.image
                                      : "assets/images/upload-img.png"
                                  }
                                  alt=""
                                />
                              )}

                              {time > 0 && isActive ? null : (
                                <div className="camera-icon">
                                  <i className="fa fa-camera"></i>
                                </div>
                              )}
                            </button>
                            <input
                              type="file"
                              onChange={(e) => {
                                if (e.target.files.length > 0) {
                                  setSelectedImage(e.target.files[0]); // store the File object
                                  setFieldValue("image", URL.createObjectURL(e.target.files[0]));
                                  // setIsActive(true);
                                  // S3FileUpload.uploadFile(
                                  //   e.target.files[0],
                                  //   config
                                  // )
                                  //   .then((data) => {
                                  //     setFieldValue("image", data.location);
                                  //     setTime(100);
                                  //     setIsActive(true);
                                  //     setTimeout(() => {
                                  //       setTime(0);
                                  //       setIsActive(false);
                                  //     }, 3000);
                                  //   })
                                  //   .catch((data) => console.log(data));
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {!isTeacherSelf && Array.isArray(companyOptions) && companyOptions.length > 0 && (
                        <div className="col-sm-12 col-md-12 mb-4">
                          <div className="form-group">
                            <label className="fw-bold">Company</label>
                            {errors.company_id &&
                              touched.company_id && (
                                <span className="text-red ms-1">
                                  {errors.company_id}
                                </span>
                              )}
                            <Select
                              className="form-control"
                              options={companyOptions}
                              isSearchable
                              placeholder="Select a company..."
                              value={companyOptions.find(option => option.value === values.company_id)}
                              onChange={option => setFieldValue('company_id', option ? option.value : '')}
                              onBlur={handleBlur}
                            />
                          </div>
                        </div>
                      )}
                      <div className="col-sm-6 col-md-6 mb-4">
                        <div className="form-group">
                          <label className="fw-bold">Full Name</label>
                          {errors.fullName && touched.fullName && (
                            <span className="text-red ms-1">
                              {errors.fullName}
                            </span>
                          )}
                          <div className="input-container">
                            <input
                              type="text"
                              className="form-control pl-5"
                              placeholder="Full Name"
                              name="fullName"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.fullName}
                            />
                            <img
                              src="assets/images/First-Name.png"
                              className="input-img"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 mb-4">
                        <div className="form-group">
                          <label className="fw-bold">Email</label>
                          {errors.email && touched.email && (
                            <span className="text-red ms-1">
                              {errors.email}
                            </span>
                          )}
                          <div className="input-container">
                            <input
                              type="email"
                              className="form-control pl-5"
                              placeholder="Email"
                              name="email"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.email}
                            />
                            <img
                              src="assets/images/Email-Address.png"
                              className="input-img"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 mb-4">
                        <div className="form-group">
                          <label className="fw-bold">Mobile No.</label>
                          {errors.mobile && touched.mobile && (
                            <span className="text-red ms-1">
                              {errors.mobile}
                            </span>
                          )}
                          <div className="input-container">
                            {/* <input
                            type="text"
                            className="form-control pl-5"
                            placeholder="Mobile Number"
                          /> */}

                            <PhoneInput
                              country="gb"
                              inputProps={{
                                name: "mobile",
                              }}
                              enableSearch
                              value={values.countryCode + values.mobile}
                              onChange={(phone, country, e, formattedValue) => {
                                if (phone.length > 0) {
                                  const raw = phone.slice(
                                    country?.dialCode?.length
                                  );
                                  setFieldValue("mobile", raw);

                                  setFieldValue(
                                    "countryCode",
                                    formattedValue?.split(" ")[0]
                                  );
                                } else {
                                  setFieldValue("mobile", "");

                                  setFieldValue("countryCode", "");
                                }
                              }}
                              onBlur={handleBlur}
                              placeholder="Mobile Number"
                              containerClass="form-control signupClass"
                              inputClass="phoneInputClass"
                            />
                            <img
                              src="assets/images/mobile.png"
                              className="input-img"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      {
                        <div className="col-sm-6 col-md-6 mb-4">
                          <div className="form-group">
                            <label className="fw-bold">Password</label>
                            {errors.password && touched.password && (
                              <span className="text-red ms-1">
                                {errors.password}
                              </span>
                            )}
                            <div className="input-container">
                              <input
                                type={values.toggle ? "password" : "text"}
                                className="form-control pl-5"
                                placeholder="Set Password"
                                name="password"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password}
                              />
                              <img
                                src="assets/images/password.png"
                                className="input-img"
                                alt=""
                              />
                              <span
                                className={
                                  values.toggle
                                    ? "pass-view field-icon "
                                    : "pass-hide field-icon "
                                }
                                onClick={(e) => {
                                  e.preventDefault();
                                  setFormikState((prevState) => {
                                    return {
                                      ...prevState,
                                      values: {
                                        ...prevState.values,
                                        toggle: !prevState.values.toggle,
                                      },
                                    };
                                  });
                                }}
                              ></span>
                            </div>
                          </div>
                        </div>
                      }
                      <div className="col-sm-12 col-md-12 mb-4">
                        <div className="form-group">
                          <h3>Address Details</h3>
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 mb-4">
                        <div className="form-group">
                          <label className="fw-bold">Property Number</label>
                          {errors?.address?.property_number &&
                            touched?.address?.property_number && (
                              <span className="text-red ms-1">
                                {errors?.address?.property_number}
                              </span>
                            )}
                          <div className="input-container">
                            <input
                              type="text"
                              className="form-control pl-5"
                              placeholder="Property Number"
                              name="address.property_number"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.address.property_number}
                            />

                            <img
                              src="assets/images/address.png"
                              className="input-img"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 mb-4">
                        <div className="form-group">
                          <label className="fw-bold">Property Name</label>
                          {errors?.address?.property_name &&
                            touched?.address?.property_name && (
                              <span className="text-red ms-1">
                                {errors?.address?.property_name}
                              </span>
                            )}
                          <div className="input-container">
                            <input
                              type="text"
                              className="form-control pl-5"
                              placeholder="Property Name"
                              name="address.property_name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.address.property_name}
                            />

                            <img
                              src="assets/images/address.png"
                              className="input-img"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 mb-4">
                        <div className="form-group">
                          <label className="fw-bold">Street Name</label>
                          {errors?.address?.street_number &&
                            touched?.address?.street_number && (
                              <span className="text-red ms-1">
                                {errors?.address?.street_number}
                              </span>
                            )}
                          <div className="input-container">
                            <input
                              type="text"
                              className="form-control pl-5"
                              placeholder="Street Name"
                              name="address.street_number"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.address.street_number}
                            />

                            <img
                              src="assets/images/address.png"
                              className="input-img"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 mb-4">
                        <div className="form-group">
                          <label className="fw-bold">Town</label>
                          {errors?.address?.town && touched?.address?.town && (
                            <span className="text-red ms-1">
                              {errors?.address?.town}
                            </span>
                          )}
                          <div className="input-container">
                            <input
                              type="text"
                              className="form-control pl-5"
                              placeholder="Town"
                              name="address.town"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.address.town}
                            />

                            <img
                              src="assets/images/address.png"
                              className="input-img"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 mb-4">
                        <div className="form-group">
                          <label className="fw-bold">Country</label>
                          {errors?.address?.country &&
                            touched?.address?.country && (
                              <span className="text-red ms-1">
                                {errors?.address?.country}
                              </span>
                            )}
                          <div className="input-container">
                            <select
                              className="form-control pl-5"
                              placeholder="Country"
                              name="address.country"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.address.country}
                            >
                              <option value="">Select Country</option>
                              <option value="U.K">U.K</option>
                            </select>

                            <img
                              src="assets/images/address.png"
                              className="input-img"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 mb-4">
                        <div className="form-group">
                          <label className="fw-bold">Postal Code</label>
                          {errors?.address?.postal_code &&
                            touched?.address?.postal_code && (
                              <span className="text-red ms-1">
                                {errors?.address?.postal_code}
                              </span>
                            )}
                          <div className="input-container">
                            <input
                              type="text"
                              className="form-control pl-5"
                              placeholder="Postal Code"
                              name="address.postal_code"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.address.postal_code}
                            />

                            <img
                              src="assets/images/address.png"
                              className="input-img"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-12 col-md-12 mb-2">
                        <label className="fw-bold">Date of Birth</label>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
                        <div className="form-group">
                          <label className="fw-bold">Year</label>

                          <div className="input-container">
                            <select
                              className="form-control pl-5"
                              placeholder="Year"
                              name="address.year"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.address.year}
                            >
                              <option value="">Select Year</option>
                              {yearList?.map((item) => {
                                return (
                                  <option value={item} key={item}>
                                    {item}
                                  </option>
                                );
                              })}
                            </select>

                            <img
                              src="assets/images/address.png"
                              className="input-img"
                              alt=""
                            />
                          </div>
                        </div>
                        {errors?.address?.year && touched?.address?.year && (
                          <span className="text-red ms-1">
                            {errors?.address?.year}
                          </span>
                        )}
                      </div>

                      <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
                        <div className="form-group">
                          <label className="fw-bold">Month</label>

                          <div className="input-container">
                            <select
                              className="form-control pl-5"
                              placeholder="Month"
                              name="address.month"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.address.month}
                            >
                              <option value="">Select Month</option>
                              {months?.map((item, i) => (
                                <option value={item?.id}>{item?.value}</option>
                              ))}
                            </select>

                            <img
                              src="assets/images/address.png"
                              className="input-img"
                              alt=""
                            />
                          </div>
                        </div>
                        {errors?.address?.month && touched?.address?.month && (
                          <span className="text-red ms-1">
                            {errors?.address?.month}
                          </span>
                        )}
                      </div>

                      <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
                        <div className="form-group">
                          <label className="fw-bold">Day</label>

                          <div className="input-container">
                            <select
                              className="form-control pl-5"
                              placeholder="Select Day"
                              name="address.day"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.address.day}
                            >
                              <option value="">Select Day</option>
                              {[
                                ...Array(
                                  values.address.month === "2" ? 28 : 31
                                ).keys(),
                              ].map((item) => {
                                return (
                                  <option value={item + 1}>{item + 1}</option>
                                );
                              })}
                            </select>

                            <img
                              src="assets/images/address.png"
                              className="input-img"
                              alt=""
                            />
                          </div>
                        </div>
                        {errors?.address?.month && touched?.address?.month && (
                          <span className="text-red ms-1">
                            {errors?.address?.month}
                          </span>
                        )}
                      </div>

                      {/* <div className="col-sm-6 col-md-6 mb-4">
                        <div className="form-group">
                          <label className="fw-bold">Date of Birth</label>

                          {errors?.address?.dob && touched?.address?.dob && (
                            <span className="text-red ms-1">
                              {errors?.address?.dob}
                            </span>
                          )}
                          <div className="input-container">
                            <DatePicker
                              containerClassName="form-control pl-5"
                              value={values.address.dob || null}
                              onChange={(val) => {
                                setFieldValue("address.dob", val.toDate());
                              }}
                              placeholder="DOB"
                              inputClass="dateInputClass"
                              maxDate={new Date()}
                              name="address.dob"
                            />
                            <img
                              src="assets/images/Date-of-Birth.png"
                              className="input-img"
                              alt=""
                            />
                            <img
                              src="assets/images/choose-date.png"
                              className="field-icon"
                              alt=""
                            />
                          </div>
                        </div>
                      </div> */}

                      {!isTeacherSelf && (
                        <>
                          <div className="col-sm-12 col-md-12 mb-4">
                            <div className="form-group">
                              <h3>Permission & Privileges</h3>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-12 mb-4">
                            <div className="table-responsive">
                              <table className="table storetable">
                                <thead className="bg-transparent">
                                  <tr>
                                    <th scope="col" className="bg-transparent">
                                      Modules
                                    </th>
                                    <th scope="col" className="text-end bg-transparent">
                                      action
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Object.keys(values.modules).map((key) => {
                                    if (key === "membership" && !isMembershipEnabled) return null;
                                    if ((key === "events" || key === "event_Type") && !isEventsEnabled) return null;
                                    return (
                                      <tr key={key}>
                                        <td className="ps-3">
                                          {key == "area" ? 'Regions' : key == "venue" ? 'Locations' : key == "discipline" ? 'Activity Types' : key == "membership" ? 'Membership Settings' : key == "classes" ? 'Sessions' : key == "booking" ? 'Bookings' : key == "events" ? 'Special Events' : key == "event_Type" ? 'Event Categories' : key == "earning" ? 'My Earnings' : key == "import_export_data" ? 'Data Import Export' : key == "newsletter" ? 'Email & Communications' : key == "notification" ? 'Notification' : key == "register" ? 'Register' : key == "user" ? 'Account Users' : key == "student" ? 'Students' : ''}
                                        </td>
                                        <td>
                                          <div className="d-flex justify-content-end action">
                                            <button className="btn" type="button">
                                              <input
                                                type="checkbox"
                                                className="toggle"
                                                checked={values.modules[key] || false}
                                                onChange={e => setFieldValue(`modules.${key}`, e.target.checked)}
                                              />
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      )}


                      <div className="col-sm-12 col-md-12 text-center">
                        <button
                          type="submit"
                          className="btn btn-save"
                          disabled={submitting}
                        >
                          {submitting ? <Loader /> : "Done"}
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </article>
    );
  }
}

export default EditTeacher;
